import { Controller } from "@hotwired/stimulus"

// Floating mobile action bar (Book Appointment / Share Story + scroll-to-top).
// Hidden while ANY anchor element (e.g. the hero/first fold or the booking widget)
// is on screen, so it never shows in the first fold or over the real widget.
// Transitions in/out smoothly via opacity + translate.
export default class extends Controller {
  static targets = ["cta"]
  static values = { anchor: String }

  connect() {
    this.visible = new Set()
    const selectors = (this.anchorValue || "").split(",").map((s) => s.trim()).filter(Boolean)
    this.anchors = selectors.map((s) => document.querySelector(s)).filter(Boolean)

    if (this.anchors.length === 0) {
      this.show(true)
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? this.visible.add(e.target) : this.visible.delete(e.target)))
      this.show(this.visible.size === 0)
    }, { rootMargin: "0px 0px -10% 0px" })

    this.anchors.forEach((a) => this.observer.observe(a))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  show(visible) {
    this.ctaTargets.forEach((el) => {
      el.style.transition = "opacity .35s cubic-bezier(.2,.7,.3,1), transform .35s cubic-bezier(.2,.7,.3,1)"
      el.style.opacity = visible ? "1" : "0"
      el.style.transform = visible ? "translateY(0)" : "translateY(1.25rem)"
      el.style.pointerEvents = visible ? "auto" : "none"
    })
  }

  top(event) {
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
